// @flow

import { isNil, omitBy } from 'lodash';

import decodeEmailUser from './decodeEmailUser';

type UserData = {
  id: number,
  username: string,
  avatar: ?Avatar
};

function getUser(user: UserData): User {
  return user.id ? user : decodeEmailUser(user);
}

function decodeFriendRequest(p = {}): FriendRequest {
  const user = getUser(p.token ? p.sender : p.recipient);
  return omitBy(
    {
      ...user,
      requestId: p.id,
      token: p.token,
      status: p.relationship_status.id,
      sentAt: new Date(p.sentAt),
      sortOrder: p.token ? 2 : 3
    },
    isNil
  );
}

export default decodeFriendRequest;
